import React, { Component } from 'react';
import { WatchlistListsModel, WatchlistModel } from '../../../domain/watchlist/WatchlistDomains';
import Icon from '../../../icons/Icon';
import LanguageUtil from '../../../util/LanguageUtil';
import WatchlistUtil from '../../../util/WatchlistUtil';
import WatchlistCustomListSourceLoader, { CustomListSourceDisplay } from '../../../util/WatchlistCustomListSourceLoader';

class State {
  public customListSources: Record<string, CustomListSourceDisplay> = {};
}

class WatchlistRemarksComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    if (this.getRemarks() == undefined || this.getRemarks().length == 0) {
      return;
    }
    return (
      <div>
        <div className={'bg-[#F2F4F7] w-full h-full rounded py-2 px-4 mt-10'}>
          <span className={'text-f-black-2 text-md'}>{LanguageUtil.get({ id: 'common.label.remarks', defaultMessage: 'Remarks' })}</span>
        </div>
        <div className={'h-full w-full pt-2'}>
          {this.getRemarks().map((data, index) => {
            return (
              <div className={'flex gap-x-2 p-2 border-b border-b-[0.5px]'} key={index}>
                <div className={'w-[20px]'}>
                  <Icon icon={'kyc_remarksicon'} color={'#607080'} size={16} />
                </div>
                <div className={'w-full h-full flex flex-col gap-y-1 text-md text-[11px] text-[#607080]'}>
                  {data['data']}
                  <div className={'flex items-center gap-x-2'}>
                    <span className={'text-md text-[#4F4F4F] bg-[#F2F4F7] rounded-xl px-[8px] py-[3px]'}>{this.getListName(data['watchlistId'])}</span>
                    {!this.isCustomList(data['watchlistId']) && (
                      <Icon icon={'link'} size={16} color={'#458EF7'} className={'cursor-pointer'} onClick={() => window.open(data['source'], '_blank')} />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  public async componentDidMount(): Promise<void> {
    await this.loadCustomListSources();
  }

  public async componentDidUpdate(prevProps: Props): Promise<void> {
    if (this.buildLoadKey(prevProps) !== this.buildLoadKey(this.props)) {
      await this.loadCustomListSources();
    }
  }

  private getRemarks = () => {
    const { selectedResponse } = this.props;
    const flattenedArray: any[] = selectedResponse.map((value) => {
      return value.watchlistRecord.remarks.map((data) => {
        return {
          data: data,
          watchlistId: value.watchlistId,
          source: value.watchlistRecord.source,
        };
      });
    });
    return [].concat(...flattenedArray);
  };

  private isCustomList = (listId: string): boolean => {
    if (this.state.customListSources[listId] != undefined) {
      return true;
    }
    return WatchlistUtil.isCustomList(this.getList(listId));
  };

  private getList = (listId: string): WatchlistListsModel | undefined => {
    const { watchlistResponse } = this.props;
    if (watchlistResponse && watchlistResponse.length > 0) {
      return watchlistResponse.find((list) => list.id == listId);
    }
    return undefined;
  };

  private getListName = (listId: string) => {
    const customListSource: CustomListSourceDisplay | undefined = this.state.customListSources[listId];
    if (customListSource != undefined) {
      return customListSource.name;
    }
    return this.getList(listId)?.name;
  };

  private buildLoadKey = (props: Props): string => {
    const watchlistIds: string = (props.selectedResponse || []).map((item: WatchlistModel) => item.watchlistId).join('|');
    const listIds: string = (props.watchlistResponse || []).map((list: WatchlistListsModel) => list.id).join('|');
    const preferred: string = props.preferredCustomListSource ? `${props.preferredCustomListSource.name}:${props.preferredCustomListSource.size}` : '';
    return `${watchlistIds}::${listIds}::${preferred}`;
  };

  private loadCustomListSources = async (): Promise<void> => {
    const customListSources: Record<string, CustomListSourceDisplay> = await WatchlistCustomListSourceLoader.load(
      (this.props.selectedResponse || []).map((item: WatchlistModel) => item.watchlistId),
      this.props.watchlistResponse || [],
      this.props.preferredCustomListSource,
    );
    this.setState({ customListSources });
  };
}

interface Props {
  selectedResponse: WatchlistModel[];
  watchlistResponse: WatchlistListsModel[];
  preferredCustomListSource?: CustomListSourceDisplay;
}

export default WatchlistRemarksComponent;
